import { HttpClient, HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { BASE_URL } from '../config/config';
import { map, tap, filter, catchError, mergeMap } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
@Injectable()
export class AuthService {

    public LOGIN_URL = BASE_URL.URL + '/login';
    public LOGOUT_URL = BASE_URL.URL + '/logout';
    // public LOGIN_URL = BASE_URL.URL;

    constructor(public http: HttpClient, private spinnerService: NgxSpinnerService) { }

    login(data): Observable<any> {
        this.spinnerService.show();
        return this.http.post(this.LOGIN_URL, data).pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError));
    }

    logout(data): Observable<any> {
        this.spinnerService.show();
        return this.http.post(this.LOGOUT_URL, data).pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        return throwError(()=> error);
    //    let errorMessage = '';
    //    if (error.error instanceof ErrorEvent) {
    //        // client-side error
    //        errorMessage = `Error: ${error.error.message}`;
    //    } else {
    //        // server side error
    //         errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    //    }
    //   // window.alert(errorMessage);
    //    return throwError(error.error);
    }
}
